<template>
  <div
    v-if="modelValue"
    class="tw-relative"
    :class="{ [randomClass]: modelValue }"
  >
    <div
      class="tw-absolute tw-top-0 tw-left-0 tw-rounded-lg tw-py-2 tw-px-3 tw-text-sm tw-leading-5 tw-break-words tw-z-100"
      :class="[customStyle]"
      :style="{ width: widthAuto ? 'auto' : width + 'px' }"
    >
      <div
        v-if="close"
        class="tw-absolute tw-top-1 tw-right-1 tw-text-xl tw-cursor-pointer"
        @click="onClose"
      >
        <IconButton
          class="!tw-p-2 tw-leading-0 tw-w-8 tw-h-8 tw-flex tw-items-center tw-justify-center"
        >
          <img :src="CloseIcon" />
        </IconButton>
      </div>
      <slot></slot>
    </div>
  </div>
</template>
<script>
import { makeid } from '@/utils';
import IconButton from '@/components/v3/base/IconButton';
import CloseIcon from '@/assets/icons/close-icon.svg';

export default {
  components: {
    IconButton,
  },

  props: {
    width: {
      type: Number,
      default: 300,
    },

    modelValue: {
      type: Boolean,
      default: false,
    },

    close: {
      type: Boolean,
      default: false,
    },

    widthAuto: {
      type: Boolean,
      default: false,
    },

    customStyle: {
      type: [String, Array],
      default: 'tw-bg-gray-700 tw-text-white',
    },
  },

  data() {
    return {
      CloseIcon,
      randomClass: '',
    };
  },

  mounted() {
    this.randomClass = makeid(10);
    window.addEventListener('click', this.clickOutSide);
  },

  unmouted() {
    window.removeEventListener('click', this.clickOutSide);
  },

  methods: {
    clickOutSide(e) {
      if (!this.close) return;
      setTimeout(() => {
        const id = `.${this.randomClass}`;
        if (!e.target || !e.target.closest(id.toString())) {
          this.$emit('update:modelValue', false);
        }
      }, 10);
    },

    onClose() {
      this.$emit('update:modelValue', false);
    },
  },
};
</script>
